/**
 * Alert sound utilities using Web Audio API
 */

let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  return audioContext;
}

interface ToneOptions {
  frequency: number;
  duration: number;
  volume?: number;
  type?: OscillatorType;
}

function playTone({ frequency, duration, volume = 0.3, type = 'sine' }: ToneOptions): void {
  try {
    const ctx = getAudioContext();

    // Resume context if suspended (browser autoplay policy)
    if (ctx.state === 'suspended') {
      ctx.resume();
    }

    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, ctx.currentTime);

    // Fade out to avoid click
    gainNode.gain.setValueAtTime(volume, ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration);

    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + duration);
  } catch (e) {
    // Silently fail if audio isn't available
    console.warn('Could not play alert sound:', e);
  }
}

/**
 * Play a warning sound (single lower tone)
 */
export function playWarningSound(): void {
  playTone({ frequency: 440, duration: 0.2, type: 'sine' });
}

/**
 * Play an alert sound (two higher tones)
 */
export function playAlertSound(): void {
  playTone({ frequency: 880, duration: 0.15, type: 'sine' });
  setTimeout(() => {
    playTone({ frequency: 880, duration: 0.15, type: 'sine' });
  }, 200);
}
